import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";
import { useUi, cx } from "../../ui";
import { WARNING_HEADROOM } from "../forecastSummary";
import { formatDayLong, formatDayShort } from "../forecastRange";

const useStyles = makeStyles({
  card: {
    flex: "1 0 120px",
    boxSizing: "border-box",
    borderRadius: 6,
    padding: "8px 12px",
    textAlign: "left",
    cursor: "pointer",
    fontFamily: "inherit",
    whiteSpace: "nowrap",
  },
  quiet: { opacity: 0.65 },
  head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, fontSize: 12 },
  day: { fontWeight: 600, color: T.fg },
  count: { color: T.mutedFg, fontVariantNumeric: "tabular-nums" },
  track: { marginTop: 8, height: 8, overflow: "hidden", borderRadius: 999, background: T.muted },
  trackFill: { height: "100%" },
  footer: { marginTop: 4, display: "flex", justifyContent: "space-between" },
});

export default function ForecastDayCard({
  day,
  capacity,
  capped,
  capacityUnit,
  selected,
  onSelect,
}) {
  const s = useStyles();
  const ui = useUi();

  const load = day.arrivals + day.departures;
  const pct = capped ? Math.min(100, Math.round((day.occupancy / capacity) * 100)) : 0;

  const over = capped && day.soldOut;
  const warn = capped && !over && day.occupancy >= capacity - WARNING_HEADROOM;

  const border = selected
    ? T.primary
    : over
    ? "rgba(255,59,48,0.5)"
    : warn
    ? "rgba(255,195,0,0.5)"
    : T.border;
  const background = selected
    ? T.accent
    : over
    ? T.dangerTint
    : warn
    ? T.warningTint
    : T.surface;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cx(s.card, load === 0 && s.quiet)}
      style={{ border: `1px solid ${border}`, background }}
      title={`Projected ${day.occupancy}${capacityUnit} on ${formatDayLong(day.date)} · ${load} movement${load === 1 ? "" : "s"}`}
    >
      <div className={s.head}>
        <span className={s.day}>{formatDayShort(day.date)}</span>
        <span className={s.count}>
          {day.occupancy}
          {capacityUnit}
        </span>
      </div>
      {capped && (
        <div className={s.track}>
          <div
            className={s.trackFill}
            style={{
              width: `${pct}%`,
              background: over ? T.danger : warn ? T.warningSolid : T.primary,
            }}
          />
        </div>
      )}
      <div className={cx(s.footer, ui.eyebrowSm)}>
        <span>+{day.arrivals} in</span>
        <span>-{day.departures} out</span>
      </div>
    </button>
  );
}
